<template>

    <div class="rental-view layout-max-width">
        <heading title="Rental View" tag="rental-view-title">
            <div class="heading__buttons">
                <b-button
                    v-if="canDelete"
                    class="ml-4"
                    @click="deleteRental()"
                    variant="danger">
                    Remove Rental from Project
                    <b-icon-trash/>
                </b-button>
            </div>
        </heading>
        <b-row class="mb-4">
            <b-col>
                <view-table
                    :model="rentalFields"
                    :data="rental"
                    :fields="['status', 'agreement_number', 'rentalCompany', 'company', 'project']">
                    <template v-slot:status="slotProps">
                        <rental-status :status="slotProps.value"/>
                    </template>
                    <template v-slot:agreement_number="slotProps">
                        {{slotProps.value}}
                    </template>
                    <template v-slot:rentalCompany="slotProps">
                        {{ getName(slotProps.value) }}<br>
                        {{ formatAddress(slotProps.value) }}<br>
                        {{ slotProps.value.email }}
                    </template>
                    <template v-slot:company="slotProps">
                        {{ getName(slotProps.value) }}
                    </template>
                    <template v-slot:project="slotProps">
                        {{ getName(slotProps.value) }}
                    </template>
                </view-table>
            </b-col>

        </b-row>
    </div>

</template>

<script>

import RentalCompany from '@/models/RentalCompany'
import Authorization from '@/providers/Authorization'

export default {
    name: 'RentalView',
    props: {
        rentalId: Number,
    },
    data () {
        return {
            rental: null,
            canDelete: false,
            rentalFields: {
                fields: {
                    status: { label: 'Status' },
                    agreement_number: { label: 'Agreement Number' },
                    rentalCompany: { label: 'Rental Company' },
                    email: { label: 'Rental Company Email' },
                    company: { label: 'Contractor Company' },
                    project: { label: 'Project' },
                }
            }
        }
    },
    methods: {
        deleteRental () {
            let rental = this.rental
            this.$api.deleteItem(this, 'rental', this.rental).then((response) => {
                this.$router.push('/project/view/' + rental.project_id)
            })

        },
        formatAddress (item) {
            return RentalCompany.formatAddress(item)
        },
        getName (item) {
            return item?.name
        }
    },
    created () {
        this.$api.getItem(this, 'rental', this.rentalId, ['company', 'project']).then((data) => {
            this.rental = data
        })
        Authorization.can({ action: 'delete', model: 'rental', arg: this.rentalId }).then((can) => {
            this.canDelete = can
        })
    }
}
</script>

<style scoped>

</style>
